var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiggle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 884,
    height: 297,
    viewBox: "0 0 884 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 148.847C88.3707 122.58 111.585 111.56 138.922 110.602C164.457 109.707 194.326 117.42 218.209 125.682C337.049 166.796 211.548 254.383 218.831 167.503C220.553 146.967 232.082 132.052 245.26 117.132C265.134 94.6297 285.771 91.2477 315.065 89.1477C366.379 85.4692 404.08 101.192 431.198 151.334C458.429 201.686 395.717 199.403 396.218 165.326C396.613 138.435 429.102 93.917 456.85 85.572C481.674 78.106 525.56 77.1618 550.207 88.8368C573.322 99.7859 589.958 127.028 602.366 148.536C610.063 161.878 613.378 183.211 603.687 196.652C581.93 226.833 538.273 223.904 540.335 183.36C541.109 168.143 552.338 151.486 562.1 140.296C572.78 128.055 582.767 117.793 599.101 107.493C667.772 64.1872 778.034 113.754 803.383 146.048",
    stroke: "url(#paint0_linear_713_42004)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_42004",
    x1: 717.494,
    y1: 148.439,
    x2: 80,
    y2: 148.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiggle);
export default __webpack_public_path__ + "static/media/swiggle.903815bcdeb379488eaa8d72e3359834.svg";
export { ForwardRef as ReactComponent };